/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Device } from '../models/Device';
import type { DeviceControlRequest } from '../models/DeviceControlRequest';
import type { DeviceControlResponse } from '../models/DeviceControlResponse';
import type { DeviceListResponse } from '../models/DeviceListResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DevicesService {
  /**
   * List user-visible devices
   * List every device the authenticated user is permitted to see.
   *
   * Reads from a 5-second TTL cache keyed per user (``devices:list:<user_id>``);
   * on miss, fans out the three HA registry calls in parallel via
   * :func:`translate_list_devices` and refreshes the cache entry.
   * @returns DeviceListResponse Successful Response
   * @throws ApiError
   */
  public static listDevicesDevicesGet(): CancelablePromise<DeviceListResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/devices',
      errors: {
        401: `Unauthorized`,
        402: `Payment Required`,
        403: `Forbidden`,
        404: `Not Found`,
        429: `Too Many Requests`,
        503: `Service Unavailable`,
      },
    });
  }
  /**
   * Get device detail
   * Fetch a single device by ID, including its ``diagnostics`` payload.
   *
   * Strategy: per-device cache lookup first (``devices:detail:<device_id>``).
   * On miss the handler re-uses the device list pipeline — the
   * translation layer needs the device-registry and area-registry to
   * enrich a single device anyway, so a targeted lookup wouldn't be
   * meaningfully cheaper than a list-and-find. The result is cached
   * individually so subsequent gets do not re-translate the full list.
   * @returns Device Successful Response
   * @throws ApiError
   */
  public static getDeviceDevicesDeviceIdGet({
    deviceId,
  }: {
    deviceId: string,
  }): CancelablePromise<Device> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/devices/{device_id}',
      path: {
        'device_id': deviceId,
      },
      errors: {
        401: `Unauthorized`,
        402: `Payment Required`,
        403: `Forbidden`,
        404: `Not Found`,
        422: `Validation Error`,
        429: `Too Many Requests`,
        503: `Service Unavailable`,
      },
    });
  }
  /**
   * Control a device
   * Apply a Mirlai-vocab action to a device.
   *
   * Flow:
   * 1. Look up the device (cache or fresh fetch).
   * 2. Translate the Mirlai action → HA service call via T-012.
   * 3. Dispatch through the pool with full error mapping.
   * 4. Invalidate the device-detail cache so the next read reflects
   * the change.
   * 5. Return ``202`` with ``applied_state`` projected from the
   * requested params on top of the current state — that's cheaper
   * than re-querying HA, and the authoritative new state will
   * arrive over the WebSocket bridge anyway.
   * @returns DeviceControlResponse Successful Response
   * @throws ApiError
   */
  public static controlDeviceDevicesDeviceIdControlPost({
    deviceId,
    requestBody,
  }: {
    deviceId: string,
    requestBody: DeviceControlRequest,
  }): CancelablePromise<DeviceControlResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/devices/{device_id}/control',
      path: {
        'device_id': deviceId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        402: `Payment Required`,
        403: `Forbidden`,
        404: `Not Found`,
        422: `Validation Error`,
        429: `Too Many Requests`,
        502: `Bad Gateway`,
        503: `Service Unavailable`,
      },
    });
  }
}
